import type { ProcessoArbitroStatus, ProcessoArbitroTipo, SituacaoProcesso } from '../types';

type BadgeVariant = 'brand' | 'neutral' | 'success' | 'warning' | 'error' | 'info';

export const STATUS_META: Record<ProcessoArbitroStatus, { label: string; variant: BadgeVariant }> =
  {
    em_citacao: { label: 'Em citação', variant: 'neutral' },
    em_andamento: { label: 'Em andamento', variant: 'brand' },
    sentenca_emitida: { label: 'Sentença emitida', variant: 'info' },
    concluido: { label: 'Concluído', variant: 'success' },
  };

export const SITUACAO_META: Record<SituacaoProcesso, { label: string; variant: BadgeVariant }> = {
  arbitro_nomeado: { label: 'Árbitro nomeado', variant: 'info' },
  aguardando_leitura: { label: 'Aguardando leitura', variant: 'warning' },
  citacao_parcial: { label: 'Citação parcial', variant: 'error' },
  aguardando_termo_arbitragem: { label: 'Aguardando Termo de Arbitragem', variant: 'warning' },
  concluso_recebido: { label: 'Concluso recebido', variant: 'brand' },
  aguardando_manifestacao: { label: 'Aguardando manifestação', variant: 'neutral' },
  aguardando_despacho: { label: 'Aguardando despacho', variant: 'brand' },
  decurso_prazo: { label: 'Decurso de prazo', variant: 'neutral' },
  aguardando_sentenca: { label: 'Aguardando sentença', variant: 'warning' },
  purga_mora: { label: 'Purga da mora', variant: 'neutral' },
  aguardando_recebimento: { label: 'Aguardando recebimento', variant: 'warning' },
  embargos_opostos: { label: 'Embargos opostos', variant: 'error' },
  janela_recurso: { label: 'Janela de recurso', variant: 'neutral' },
  transito_julgado: { label: 'Trânsito em julgado', variant: 'success' },
  desistencia: { label: 'Desistência', variant: 'neutral' },
};

export const TIPO_LABELS: Record<ProcessoArbitroTipo, string> = {
  rescisao: 'Rescisão contratual',
  despejo_fp: 'Despejo por falta de pagamento',
  despejo_alug: 'Despejo c/c cobrança de aluguéis',
  cobranca: 'Cobrança',
};

export const CITACAO_VIA_LABEL: Record<string, string> = {
  ar: 'Postal com AR',
  eletronica: 'Eletrônica',
  edital: 'Edital',
  oficial: 'Oficial de Justiça',
};
